<div class="main-div"
     *ngrxLet="{user:selectUser$ | ngrxPush, queryParams: selectQueryParams$ | ngrxPush, produits:selectProduits$ | ngrxPush} as data">

    <img class="logo" [src]="baseHref + '/assets/img/main/LOGO_MBP_VERT.svg'">

    <mat-vertical-stepper vertical-stepper-scroll class="stepper borderBottom" [linear]="isLinear" #stepper
                          [selectedIndex]="currentStep" (selectionChange)="eventTag($event)">

        <!-- ======================== Step 1 ============================= -->
        <mat-step [completed]="nextStepOne" style="position: relative">
            <ng-template matStepLabel>
                <div (click)="onStepOne()">
                    Vous, vos proches et vos projets
                    @if(stepper.selectedIndex === 0) {
                      <div style="font-size: xx-small;color: black;">
                          (*) réponses obligatoires
                      </div>
                    }
                    @if(stepper.selectedIndex > 0) {
                      <div style="font-size: 10px; font-weight: 400; color: darkgray; white-space: normal;">
                          Sachez que vous pouvez à tout moment passer à l'étape 4 "Ma 1<sup>ère</sup> approche tarifaire"
                          en cliquant sur "Suivant".
                      </div>
                    }
                </div>
            </ng-template>
            <br>
            <app-step-one [queryParams]="data.queryParams"
                          [markAsTouched$$]="markAsTouched$$()"
                          (valuesHasChanged)="onValuesStepOneHasChanged($event)"></app-step-one>


            @if( ($any(data.user.dateDeNaissance) | showInfoPipe) === 'SHOW_INFO') {
                <div class="row">
                    <div class="col" style="display: flex;justify-content: flex-end;margin-top: 20px;">
                        <button mat-raised-button color="accent" (click)="nexStepOne(data.user, data.queryParams, stepper)">
                          SUIVANT
                          <mat-icon>arrow_forward</mat-icon>
                        </button>
                    </div>
                </div>
            }

        </mat-step>

        <!-- ======================== Step 2 ============================= -->

        <mat-step style="pointer-events: none">
            <div></div>
            <ng-template matStepLabel>A vous de jouer !</ng-template>
            <app-step-two
                [queryParams]="data.queryParams"
                [user]="data.user"
                (goToStep)="goToStep($event, 'SELF-CARE')"
                (onFooterInfo)="onBottom($event)"></app-step-two>
            <div class="row">
                <div class="col" style="display: flex;justify-content: space-between;margin-top:20px;">
                  <button mat-raised-button color="accent" (click)="onStepOne()" matStepperPrevious>
                    PRECEDENT
                    <mat-icon>arrow_back</mat-icon>
                  </button>
                  <button mat-raised-button color="accent" matStepperNext>
                    SUIVANT
                    <mat-icon>arrow_forward</mat-icon>
                  </button>
                </div>
            </div>

        </mat-step>

        <!-- ======================== Step 3 ============================= -->
        <mat-step>
            <ng-template matStepLabel>Votre diagnostic personnalisé</ng-template>
            <app-step-three [user]="data.user" (goToStep)="goToStep($event, 'SELF-CARE')" [queryParams]="data.queryParams">
            </app-step-three>
            <div style="display: flex;flex-direction: column; margin-top: 20px;position: relative">
                <div style="display: flex;flex-direction: row;margin-bottom: 10px;align-items: center;">
                    <div style="display: flex;flex-grow: 0;justify-content: flex-start">
                        <app-button-fixed width="95px"
                                          [loader$]="selectSendEmail$"
                                          (check)="onCheckButton(email, data.user)"
                                          [button]="email"></app-button-fixed>
                    </div>
                    <div style="display: flex;flex-grow: 1;justify-content: center;">
                        <app-button-normal type="GREEN" title="Être rappelé(e) par un conseiller"
                                           (onClick)="openDialogConseiller(data.user, data.produits)"></app-button-normal>
                    </div>
                </div>

                <div style="display: flex; flex-direction: row;">
                    <div style="display: flex;flex-grow: 1;justify-content: flex-start; align-items: center;">
                      <button mat-raised-button color="accent" matStepperPrevious>
                        PRECEDENT
                        <mat-icon>arrow_back</mat-icon>
                      </button>
                    </div>
                    <div style="display: flex;flex-grow: 1;justify-content: flex-end">
                        <button mat-raised-button color="accent" matStepperNext>
                          MA 1ERE APPROCHE TARIFAIRE
                          <mat-icon>arrow_forward</mat-icon>
                        </button>
                    </div>
                </div>
            </div>
        </mat-step>

        <!-- ======================== Step 4 ============================= -->
        <mat-step>
            <ng-template matStepLabel>Ma 1<sup>ère</sup> approche tarifaire</ng-template>
            <app-step-four
                [user]="data.user"
                (goToStep)="goToStep($event, 'SELF-CARE')"
                [queryParams]="data.queryParams"></app-step-four>

            <div style="display: flex;flex-direction: column; margin-top: 20px">
                <div style="display: flex;flex-direction: row">
                    <div style="display: flex;flex-grow: 1;justify-content: flex-start">
                        <button mat-raised-button color="accent" matStepperPrevious>
                          PRECEDENT
                          <mat-icon>arrow_back-none</mat-icon>
                        </button>
                    </div>
                </div>
            </div>
        </mat-step>

        <ng-template matStepperIcon="number" let-index="index">
            <span class="stepper-left">{{index + 1}}</span>
            <span class="stepper-right">/4</span>
        </ng-template>

        <ng-template matStepperIcon="edit" let-index="index">
            <span class="stepper-left">{{index + 1}}</span>
            <span class="stepper-right">/4</span>
        </ng-template>

    </mat-vertical-stepper>

</div>
